export default "__VITE_ASSET__CyWX2ct3__"